<template>
  <el-card class="mt-10">
    <div class="toolbar">
      <el-button-group>
        <el-button size="small" @click="_openAddOrgModal">
          {{ $t('orgTree.add') }}
        </el-button>
        <el-button size="small" @click="_openEditOrgModel">
          {{ $t('orgTree.edit') }}
        </el-button>
        <el-button size="small" @click="_openDeleteOrgModel">
          {{ $t('orgTree.delete') }}
        </el-button>
      </el-button-group>
    </div>
    
    <div class="mt-10">
      <el-tree
        ref="orgTree"
        :data="orgTreeInfo.orgs"
        node-key="id"
        :props="defaultProps"
        :default-expand-all="true"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>

    <add-org ref="addOrg" @refresh="_loadOrgs"></add-org>
    <edit-org ref="editOrg" @refresh="_loadOrgs"></edit-org>
    <delete-org ref="deleteOrg" @refresh="_loadOrgs"></delete-org>
  </el-card>
</template>

<script>
import { listOrgTree } from '@/api/frame/orgApi'
import AddOrg from '@/components/frame/addOrg/addOrg'
import EditOrg from '@/components/frame/editOrg/editOrg'
import DeleteOrg from '@/components/frame/deleteOrg/deleteOrg'
import {getShopId} from '@/api/shop/shopApi'

export default {
  name: 'OrgTree',
  components: {
    AddOrg,
    EditOrg,
    DeleteOrg
  },
  props: {
    callBackListener: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      orgTreeInfo: {
        orgs: [],
        orgId: '',
        curOrg: {}
      },
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  mounted() {
    this._loadOrgs()
  },
  methods: {
    _loadOrgs() {
      const params = {
        shopId: getShopId()
      }

      listOrgTree(params).then(response => {
        this.orgTreeInfo.orgs = [response.data]
      })
    },
    handleNodeClick(data) {
      this.orgTreeInfo.curOrg = data
      this.orgTreeInfo.curOrg.orgId = data.id
      this.$emit('switchOrg', {
        orgId: data.id,
        orgName: data.text
      })
    },
    _openAddOrgModal() {
      if (!this.orgTreeInfo.curOrg.id) {
        this.$message.warning(this.$t('orgTree.selectOrgFirst'))
        return
      }
      this.$refs.addOrg.open({
        parentOrgId: this.orgTreeInfo.curOrg.id,
        parentOrgName: this.orgTreeInfo.curOrg.text
      })
    },
    _openEditOrgModel() {
      if (!this.orgTreeInfo.curOrg.id) {
        this.$message.warning(this.$t('orgTree.selectOrgFirst'))
        return
      }
      this.$refs.editOrg.open(this.orgTreeInfo.curOrg)
    },
    _openDeleteOrgModel() {
      if (!this.orgTreeInfo.curOrg.id) {
        this.$message.warning(this.$t('orgTree.selectOrgFirst'))
        return
      }
      this.$refs.deleteOrg.open(this.orgTreeInfo.curOrg)
    },
    refreshTree() {
      this._loadOrgs()
    }
  }
}
</script>

<style scoped>
.mt-10 {
  margin-top: 10px;
}
.toolbar {
  margin-bottom: 10px;
}
</style>